import { Button, Flex, Modal, Pill, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { ApDataContext } from "../../../../../views/Plan";
import { Card } from "../../../../Card";
import { MeasureForm } from "../../ComponentForms/MeasureForm";
import RichTextViewer from "../../../../RichTextArea/RichTextViewer";

const AssessmentTemplateCard = ({ templateFields }) => {
  const { t } = useTranslation();
  const { extraData } = useContext(ApDataContext);
  const [openModal, setOpenModal] = useState(false);

  const AssessmentPill = () => {
    return (
      <Pill color="info" themeOverride={{ maxWidth: "30rem" }}>
        {t(
          templateFields.type === "external"
            ? templateFields.collecting_evidence
              ? "assessment.externalJuriedAssessment"
              : "assessment.externalAssessment"
            : templateFields.collecting_evidence
              ? "assessment.canvasJuriedAssessment"
              : "assessment.canvasAssessment"
        )}
      </Pill>
    );
  };

  return (
    <Card style={{ backgroundColor: "#FFFFFF", padding: "0" }}>
      <Flex wrap="wrap" padding="small">
        <Flex.Item>
          <AssessmentPill />
        </Flex.Item>
        {templateFields.description && (
          <Flex.Item size="100%" padding="x-small 0 0 0">
            <RichTextViewer
              label={
                <Text weight="bold" size="small">
                  {t("ratingScale.description")}:
                </Text>
              }
              value={templateFields.description}
            />
          </Flex.Item>
        )}
      </Flex>
      <Modal.Footer>
        <Button color="primary" size="small" onClick={() => setOpenModal(true)}>
          {t("planTemplates.build")}
        </Button>
      </Modal.Footer>
      <MeasureForm
        openModal={openModal}
        setOpenModal={setOpenModal}
        templateFields={templateFields}
        courseLevels={extraData.courseLevels}
        assignmentTypes={extraData.assignmentTypes}
        acSubs={extraData.acSubs}
        allCycles={extraData.cycles}
        programs={extraData.programs}
        inTemplate
      />
    </Card>
  );
};

export default AssessmentTemplateCard;
